import React, { useEffect, useState } from "react";
import { api, formatRupiah, formatDate } from "../lib/api";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { HeartHandshake } from "lucide-react";

export default function Customers() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/customers").then((r)=>setItems(r.data)); }, []);
  const ltv = items.reduce((a,b)=>a+(b.lifetime_value||0),0);

  return (
    <div className="space-y-5" data-testid="customers-page">
      <div>
        <h1 className="text-2xl font-bold" style={{fontFamily:"Outfit"}}>Pelanggan</h1>
        <p className="text-sm text-slate-500">Pelanggan yang berhasil dikonversi dari deal Won. Lifetime value total: <b className="text-emerald-700">{formatRupiah(ltv)}</b></p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((c)=>(
          <Card key={c.id} className="p-5 hover:shadow-md transition" data-testid={`customer-card-${c.id}`}>
            <div className="flex items-start justify-between">
              <div>
                <div className="w-10 h-10 rounded-lg bg-emerald-50 flex items-center justify-center text-emerald-700 mb-3">
                  <HeartHandshake className="w-5 h-5"/>
                </div>
                <h3 className="font-semibold text-slate-900">{c.name}</h3>
                <p className="text-xs text-slate-500">{c.contact_name}</p>
              </div>
              <Badge variant="outline" className="text-[10px]">Aktif</Badge>
            </div>
            <div className="mt-4 flex items-end justify-between">
              <div>
                <div className="text-xs text-slate-500">Lifetime Value</div>
                <div className="text-lg font-bold text-emerald-800">{formatRupiah(c.lifetime_value)}</div>
              </div>
              <div className="text-right text-xs text-slate-500">Terakhir<br/>{formatDate(c.last_purchase)}</div>
            </div>
            <div className="mt-3 flex flex-wrap gap-1">
              {(c.products || []).slice(0,3).map((p,i)=><Badge key={i} variant="outline" className="text-[10px]">{p}</Badge>)}
            </div>
          </Card>
        ))}
        {items.length === 0 && <Card className="p-8 text-center text-slate-500 col-span-full">Belum ada pelanggan. Menangkan deal untuk otomatis menjadi pelanggan.</Card>}
      </div>
    </div>
  );
}
